import { cn } from "../../../lib/utils";

export const SectionTitle = ({ title, className }) => (
  <div
    className={cn(
      "text-2xl md:text-4xl font-bold drop-shadow-md text-center",
      className
    )}
  >
    {title}
  </div>
);
